import { UserRoleDisplay } from '@/types/backend/models/UserRole';

export enum DistributionChannel {
  Direct = 'Direct',
  Distribution = 'Distribution',
}

export enum BooleanDisplay {
  Enabled = 'Enabled',
  NotEnabled = 'Not-Enabled',
}

export const getDistributionChannel = (distributionSignDate?: string | null) =>
  distributionSignDate ? DistributionChannel.Distribution : DistributionChannel.Direct;

export const getUserRoleDisplay = (role: number): string => UserRoleDisplay[role];

export const getBooleanDisplay = (condition: boolean) =>
  condition ? BooleanDisplay.Enabled : BooleanDisplay.NotEnabled;
